export default __webpack_public_path__ + "static/media/NTORQ 125_3.fbe6a3dc.webp";